import * as React from "react";
import { observer, inject } from "mobx-react";
import { RouteStore, QueryRoute } from "bernie-core";
import { UitkLink } from "uitk-react-link";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { Layer } from "bernie-view";

export enum DIALOG_QUERY {
  NAME = "pwaDialogTripCost",
  VALUE = "open"
}

interface LinkListViewProps {
  text: string;
  children: React.ReactNode;
  routeStore?: RouteStore;
}

@inject("routeStore")
@observer
export class LinkListView extends React.Component<LinkListViewProps> {
  constructor(props: LinkListViewProps) {
    super(props);
  }

  public render() {
    const { text, routeStore, children } = this.props;

    const openDialog = (e: MouseEvent) => {
      e.preventDefault();

      return routeStore && routeStore.updateSearch({ [DIALOG_QUERY.NAME]: DIALOG_QUERY.VALUE });
    };

    return (
      <div className="LinkListView uitk-grid">
        <UitkLink className="uitk-grid all-grid-align-start">
          <TrackedLink
            moduleName="tripCostEstimator"
            rfrr="links-view-list"
            href="#"
            onClick={openDialog}
          >
            {text}
          </TrackedLink>
        </UitkLink>
        <QueryRoute query={{ [DIALOG_QUERY.NAME]: DIALOG_QUERY.VALUE }}>
          <Layer id={DIALOG_QUERY.NAME}>{children}</Layer>
        </QueryRoute>
      </div>
    );
  }
}

export default LinkListView;
